import type { QuickFilter } from "../../../DataTable-modular/types";
import { COMMON_QUICK_FILTERS } from "../common/common-quick-filters";

// ============================================================================
// TIME ENTRY QUICK FILTERS
// ============================================================================

// Time Entry specific quick filters
export const TIME_ENTRY_QUICK_FILTERS: QuickFilter[] = [
  COMMON_QUICK_FILTERS.client,
  COMMON_QUICK_FILTERS.approvalStatus,
  COMMON_QUICK_FILTERS.billableStatus,
  COMMON_QUICK_FILTERS.dateWorked,
  COMMON_QUICK_FILTERS.hours,
  COMMON_QUICK_FILTERS.description,
  COMMON_QUICK_FILTERS.user,
  COMMON_QUICK_FILTERS.ticketNumber,
  COMMON_QUICK_FILTERS.syncStatus,
];

// Time Reports specific quick filters (alias for TIME_ENTRY_QUICK_FILTERS)
export const TIME_QUICK_FILTERS: QuickFilter[] = TIME_ENTRY_QUICK_FILTERS;
